import { backendApi } from '@app/services'

import { Language } from './types'

export const fetchLanguages = async (lang: string) => {
  const { data } = await backendApi.get<Language[]>(
    `/languages/${lang}`
  )
  return data
}
